import type { AppEmbedData_AppType } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

export const VERTICAL_EMBED_TYPE = 'wix-draft-plugin-vertical-embed';

interface VerticalPluginConfig {
  slimLayout?: boolean;
}

export type EmbedItem = {
  id: string;
  name: string;
  pageUrl: string;
  imageSrc: string;
  imageWidth: number;
  imageHeight: number;
  description: string;
  scheduling: string;
  location: string;
  thumbnail: string;
  html: string;
  durations?: number;
};

export type VerticalApiType = Lowercase<
  Exclude<AppEmbedData_AppType, AppEmbedData_AppType.UNRECOGNIZED>
>;

export interface VerticalEmbedPluginEditorConfig extends EditorPluginConfig, VerticalPluginConfig {
  getIsVisiblePromise?: (type: string, locale: string) => Promise<boolean>;
  exposeEmbedButtons?: string[];
  slimLayout?: boolean;
  verticalsApi?: (
    type: VerticalApiType,
    locale?: string
  ) => {
    search: (searchInput: string) => Promise<EmbedItem[]>;
    items: Promise<EmbedItem[]>;
  };
}
export interface VerticalEmbedPluginViewerConfig extends ViewerPluginConfig {
  changeBaseUrl?: (url: string) => string;
  disabled?: boolean;
  slimLayout?: boolean;
}
